import HTTP from "@/utils/http";
/**
 *
 * @param {*} params
 */

// 实名认证
export const postUser = (params) => HTTP("/api/user/bindMoblie", params, false);

// 发送验证码
export const getCode = (params) => HTTP("/api/sms/send", params, false);

// 责任部门工单列表
export const getMyEventOrder = (params) =>
  HTTP("/api/v2/work/myWork", params, false);
// 责任部门工单详情
export const getMyEventDetail = (params) =>
  HTTP("/api/v2/work/index", params, false);

// 处理工单
export const changeWork = (params) =>
  HTTP("/api/v2/work/change", params, false);

// 获取部门列表
export const getAreaList = (params) =>
  HTTP("/api/v2/area/areaList", params, false);
// 责任部门列表
export const getDepartmentList = (params) =>
  HTTP("api/v2/cate/categoryInfo", params, false);
// 督查员列表
export const getInspectorList = (params) =>
  HTTP("/api/v2/work/inspectorList", params, false);
// 重新指派
export const assignNew = (params) => HTTP("/api/v2/event/edit", params, false);

// 删除工单
export const delOrder = (params) =>
  HTTP("/api/v2/work/delOrder", params, false);

//编辑工单
export const editOrder = (params) =>
  HTTP("/api/v2/work/editOrder", params, false);
